/**
 *
 * Asynchronously loads the component for Course
 *
 */

import { lazyLoad } from 'utils/loadable';

export const Course = lazyLoad(() => import('./index'));
